export interface SearchSelectionState {
  active: boolean
  ids: Set<string>
}

export function startSearchSelection(noteId?: string): SearchSelectionState {
  return {
    active: true,
    ids: noteId ? new Set([noteId]) : new Set(),
  }
}

export function dismissSearchSelection(): SearchSelectionState {
  return { active: false, ids: new Set() }
}

export function toggleSearchSelection(
  selection: SearchSelectionState,
  noteId: string,
): SearchSelectionState {
  const ids = new Set(selection.ids)
  if (ids.has(noteId)) ids.delete(noteId)
  else ids.add(noteId)

  return {
    active: ids.size > 0,
    ids,
  }
}
